(function () {
    'use strict';
    angular.module('app.common')
        .directive('opportunityCard', [function () {
            var directive = {
                templateUrl: '/app/common/opportunity-card.html',
                scope: {
                    opportunity: '<',
                    ordering: '<'
                },
                restrict: 'EA',
                bindToController: false,
                replace: false,
            };
            return directive;
        }]);
})();